import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/analytics";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const app = firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const db = firebase.firestore();

// Safe analytics initialization - won't block crawlers
let analyticsInstance: firebase.analytics.Analytics | null = null;

try {
  // Only initialize analytics for real users, not bots
  if (typeof window !== 'undefined' &&
    typeof navigator !== 'undefined' &&
    !navigator.userAgent.includes('bot') &&
    !navigator.userAgent.includes('crawler') &&
    !navigator.userAgent.includes('spider')) {
    analyticsInstance = firebase.analytics();
  }
} catch (error) {
  // Silently fail if analytics can't be initialized
  console.warn('Analytics initialization failed:', error);
}

// Safe analytics wrapper
export const analytics = {
  logEvent: (eventName: string, parameters?: any) => {
    try {
      if (analyticsInstance) {
        analyticsInstance.logEvent(eventName, parameters);
      }
    } catch (error) {
      // Silently fail for bots/crawlers
    }
  },
  setAnalyticsCollectionEnabled: (enabled: boolean) => {
    try {
      if (analyticsInstance) {
        analyticsInstance.setAnalyticsCollectionEnabled(enabled);
      }
    } catch (error) {
      // Silently fail
    }
  },
  setUserId: (userId: string) => {
    try {
      if (analyticsInstance) {
        analyticsInstance.setUserId(userId);
      }
    } catch (error) {
      // Silently fail
    }
  }
};